'use client'

import { IS_PROD } from '@/lib/constant'
import type { User } from '@/lib/types'

let initialized = false

export async function initMixpanelReplay(user?: User | null) {
  if (typeof window === 'undefined') return
  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || ''
  if (!MIXPANEL_TOKEN) return

  try {
    const mp = (await import('mixpanel-browser')).default

    // Already initialized: only update identification
    if (initialized) {
      if (user?._id) mp.identify(String(user._id))
      ;(window as any).mixpanel = mp
      return
    }

    // Project-level Replay configuration (no envs)
    const options: Record<string, any> = {
      debug: !IS_PROD,
      // Enable Session Replay sampling at 1%
      record_sessions_percent: 100,
      // End replay after 30 minutes of inactivity (default value)
      record_idle_timeout_ms: 1800000,
      // Do not mask text or block images/videos per request
      record_mask_text_selector: '',
      record_block_selector: '',
      // Not enabling heatmap or canvas by default
      record_heatmap_data: true,
      // record_canvas: true,

      // Fix mutex lock timeout issue when multiple tabs are open
      // Use cookies for persistence to avoid localStorage mutex issues
      persistence: 'cookie',
      // Disable cross-subdomain tracking (not needed for single domain)
      cross_subdomain_cookie: false,
      // Set secure cookie in production
      secure_cookie: IS_PROD,
    }

    mp.init(MIXPANEL_TOKEN, options)

    if (user?._id) {
      mp.identify(String(user._id))
    }
    ;(window as any).mixpanel = mp
    initialized = true
  } catch (err) {
    console.error('Failed to initialize Mixpanel (Replay):', err)
  }
}

export function startSessionRecording() {
  try {
    const mp = (window as any).mixpanel
    if (mp && typeof mp.start_session_recording === 'function') {
      mp.start_session_recording()
    }
  } catch {}
}

export function stopSessionRecording() {
  try {
    const mp = (window as any).mixpanel
    if (mp && typeof mp.stop_session_recording === 'function') {
      mp.stop_session_recording()
    }
  } catch {}
}

export function getSessionReplayUrl(): string | null {
  try {
    const mp = (window as any).mixpanel
    if (mp && typeof mp.get_session_replay_url === 'function') {
      return mp.get_session_replay_url() || null
    }
  } catch {}
  return null
}
